import { TemplateCard } from "../template-card";
import * as Styled from "./VideoOnDemand.styled";
import { useNavigate } from "react-router-dom";
import { getLayoutImage, IUploadCategory, LayoutTemplates, Loader } from "../../../libs";
import React from "react";
import { SelectTemplate } from "../select-template";
import { userService } from "../../../services";
import { toast } from "react-toastify";



export const VideoOnDemand: React.FC = () => {
    const navigate = useNavigate();
    const [uploadCategory, setUploadCategory] = React.useState<IUploadCategory | null>(null);
    const [loading, setLoading] = React.useState<boolean>(true);

    const [generalVODTemplate, setGeneralVODTemplate] = React.useState<LayoutTemplates>(LayoutTemplates.Layout1);
    const [filmFestivalVODTemplate, setFilmFestivalVODTemplate] = React.useState<LayoutTemplates>(LayoutTemplates.Layout1);
    const [originalGeneralTemplate, setOriginalGeneralTemplate] = React.useState<LayoutTemplates>(LayoutTemplates.Layout1);
    const [originalFilmFestivalTemplate, setOriginalFilmFestivalTemplate] = React.useState<LayoutTemplates>(LayoutTemplates.Layout1);

    const fetchVODTemplates = React.useCallback(async () => {
        const generalTemplate = await userService.getUserKVStoreKey("general_vod_template");
        const filmFestivalTemplate = await userService.getUserKVStoreKey("film_festival_vod_template");

        if (generalTemplate?.value) {
            setGeneralVODTemplate(parseInt(generalTemplate.value));
            setOriginalGeneralTemplate(parseInt(generalTemplate.value));
        }
        if (filmFestivalTemplate?.value) {
            setFilmFestivalVODTemplate(parseInt(filmFestivalTemplate.value));
            setOriginalFilmFestivalTemplate(parseInt(filmFestivalTemplate.value));
        }
        setLoading(false);
    }, [setGeneralVODTemplate, setFilmFestivalVODTemplate]);

    const saveVODTemplates = React.useCallback(async () => {
        setLoading(true);
        try {
            if (generalVODTemplate !== originalGeneralTemplate) {
                await userService.setUserKVStoreKey("general_vod_template", generalVODTemplate);
                toast.success("General VOD template saved successfully!");
            }
            if (filmFestivalVODTemplate !== originalFilmFestivalTemplate) {
                await userService.setUserKVStoreKey("film_festival_vod_template", filmFestivalVODTemplate);
                toast.success("Film Festival VOD template saved successfully!");
            }
            setOriginalGeneralTemplate(generalVODTemplate);
            setOriginalFilmFestivalTemplate(filmFestivalVODTemplate);
        } catch (error) {
            console.error("Error saving VOD templates:", error);
        }
        setLoading(false);
    }, [generalVODTemplate, filmFestivalVODTemplate]);

    React.useEffect(() => {
        fetchVODTemplates();
    }, [fetchVODTemplates]);

    return (
        <Styled.StyledContainer>
            <Styled.Header>
                <Styled.LeftSection>
                    Video on Demand
                </Styled.LeftSection>
                <Styled.RightSection>
                    <Styled.CustomButton variant="outline-secondary" onClick={() => {
                        uploadCategory === null ? navigate(-1) : setUploadCategory(null);

                    }}>Go Back</Styled.CustomButton>
                    <Styled.SaveButton variant="primary" onClick={saveVODTemplates}>Save</Styled.SaveButton>
                </Styled.RightSection>
            </Styled.Header>
            <Styled.Description>
                Here you can organize all the content to see how it will appear on your page.
            </Styled.Description>
            <Styled.SelectTemplateWrapper>
                {
                    loading && (
                        <Styled.LoadingOverlay>
                            <Loader message=" "/>
                        </Styled.LoadingOverlay>
                    )
                }
                {
                    uploadCategory === null ? (
                        <>
                            <TemplateCard
                                title="General Video on Demand"
                                subtitle="All the videos you have stored in the VOD folder will be displayed here."
                                svgSrc={getLayoutImage(generalVODTemplate)}
                                onClick={() => setUploadCategory(IUploadCategory.GENERAL)}
                            />
                            <TemplateCard
                                title="Film Festival Video on Demand"
                                subtitle="All the videos you have stored in the VOD folder will be displayed here."
                                svgSrc={getLayoutImage(filmFestivalVODTemplate)}
                                onClick={() => setUploadCategory(IUploadCategory.FILM_FESTIVAL)}
                            />
                        </>
                    ) : (
                        <SelectTemplate
                            onBack={() => setUploadCategory(null)}
                            selectedTemplate={uploadCategory === IUploadCategory.GENERAL ? generalVODTemplate : filmFestivalVODTemplate}
                            onTemplateSelect={(template: LayoutTemplates) => {
                                if (uploadCategory === IUploadCategory.GENERAL) {
                                    setGeneralVODTemplate(template);
                                } else {
                                    setFilmFestivalVODTemplate(template);
                                }
                            }}
                            changed={
                                uploadCategory === IUploadCategory.GENERAL ?
                                    generalVODTemplate !== originalGeneralTemplate :
                                    filmFestivalVODTemplate !== originalFilmFestivalTemplate
                            }
                        />
                    )
                }
            </Styled.SelectTemplateWrapper>

        </Styled.StyledContainer>

    )
}
